import server from 'utils/request';

/**
 * 枚举接口
 * @param enumKey
 */
export function getEnumDict(enumKey) {
  var params = {
    enumKey
  }
  return server({
    url: '/common/getEnumDict',
    method: 'get',
    params
  })
}

/**
 * 字典接口
 * @param enumKey
 */
export function getDic(data) {
  return server({
    url: '/common/getDictByGroupParent',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取案件详情
 * @param enumKey
 */
export function getCaseDetails(caseTempNo) {
  var data = {
    caseTempNo
  };
  return server({
    url: '/case/details',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

export function letter(letterId) {
  var data = {
    letterId
  };
  return server({
    url: 'case/letter/view',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 下载接口
 * @param filepath
 */
export function showImg(filepath) {
  var params = {
    filepath
  };
  return server({
    url: '/common/file/download',
    method: 'get',
    responseType: 'blob',
    params
  })
}
/**
 * 下载仲裁员声明书
 * @param filepath
 */
export function arbStatement(caseTempNo) {
  var params = {
    caseTempNo
  };
  return server({
    url: '/common/download/arbStatement',
    method: 'get',
    responseType: 'blob',
    params
  })
}
/**
 *  检查文件是否存在
 * @param filepath
 */
export function download(filepath) {
  var params = {
    filepath
  };
  return server({
    url: '/common/file/check',
    method: 'get',
    params
  })
}

/**
 * 下载接口
 * @param caseTempNo
 */
export function downloadDraft(caseTempNo) {
  var params = {
    caseTempNo
  };
  return server({
    url: '/case/judge/download/check',
    method: 'get',
    params
  })
}

/**
 *
 * @param money
 */
export function countFee(money) {
  var data = {
    money
  };
  return server({
    url: '/common/countFee',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 获取手机验证码
 * @param data
 */
export function getCode(data) {
  return server({
    url: '/common/getSmsCode',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}


/**
 * 验证是否登录
 */
export function auditLog() {
  return server({
    url: '/common/refresh',
    method: 'post'
  })
}

/**
 * 首页 区块链信息
 */
export function blockchainInfo() {
  return server({
    url: '/blockchain/info',
    method: 'get'
  })
}

/**
 * 首页 区块链最新交易信息接口
 */
export function txList() {
  return server({
    url: 'blockchain/txList',
    method: 'get'
  })
}

/**
 *  获取审核步骤
 * @param data
 * 1:仲裁员回避2：管辖异议3：反请求4：裁决书审核
 */
export function step(data) {
  return server({
    url: '/case/judge/step',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 进入庭审
 * @param data
 */
export function entert_trial(data) {
  return server({
    url: '/ebcase/trial/page',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 审理记录
 * @param data
 */
export function trialList(data) {
  return server({
    url: '/ebcase/trial/list',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}
/**
 * 邮件预览
 * @param data
 */
export function letterPreview(data) {
  return server({
    url: 'case/letter/preview',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}


// WEBPACK FOOTER //
// ./src/api/common.js